import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Carousel from 'react-bootstrap/Carousel';
import FsLightbox from 'fslightbox-react';
import { useTranslation } from 'react-i18next';
import './Certificates.scss';

const Certificates = () => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1
  });
  const { t } = useTranslation();

  const certificates = [
    {
      id: 1,
      image: 'https://placehold.co/600x400/d1d5db/31343C?text=ISO+Certificate',
      title: t('certificates.iso.title'),
      description: t('certificates.iso.description')
    },
    {
      id: 2,
      image: 'https://placehold.co/600x400/d1d5db/31343C?text=GOTS+Certificate',
      title: t('certificates.gots.title'),
      description: t('certificates.gots.description')
    }
  ];

  return (
    <section id="certificates" className="certificates-section">
      <Container>
        <div className="section-header text-center mb-5" data-aos="fade-down">
          <h2>{t('certificates.title')}</h2>
          <p>{t('certificates.subtitle')}</p>
        </div>
        
        <Carousel className="certificates-carousel" interval={5000} touch={true}>
          {certificates.map((cert, index) => (
            <Carousel.Item key={cert.id}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div className="certificate-image" 
                       data-aos="fade-right"
                       data-aos-duration="1000"
                       onClick={() => setLightboxController({
                         toggler: !lightboxController.toggler,
                         slide: index + 1
                       })}>
                    <img src={cert.image} alt={cert.title} />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="certificate-content"
                       data-aos="fade-left"
                       data-aos-duration="1000"
                       data-aos-delay="200">
                    <h3>{cert.title}</h3>
                    <p>{cert.description}</p>
                  </div>
                </Col>
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>

      <FsLightbox
        toggler={lightboxController.toggler}
        sources={certificates.map(cert => cert.image)}
        slide={lightboxController.slide}
      />
    </section>
  );
};

export default Certificates;